module.exports = __webpack_public_path__ + "flyer_background_cupcakes_137-332c9bf756e08867c02a6eba3c93e6e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_cupcakes_137.jpg
// module id = 1635
// module chunks = 1